module.exports = __webpack_public_path__ + "img/pt3.12fce2d0.png";